import {
  FETCH_TRACKED_KEYWORDS_IN_PROGRESS,
  FETCH_TRACKED_KEYWORDS_SUCCESSFUL,
  FETCH_TRACKED_KEYWORDS_FAILED,
  FETCH_TRACKED_KEYWORDS_COUNT_IN_PROGRESS,
  FETCH_TRACKED_KEYWORDS_COUNT_SUCCESSFUL,
  FETCH_TRACKED_KEYWORDS_COUNT_FAILED,
  FETCH_TOP_DOMAINS_IN_PROGRESS,
  FETCH_TOP_DOMAINS_SUCCESSFUL,
  FETCH_TOP_DOMAINS_FAILED,
  FETCH_KEYWORD_OVERVIEW_IN_PROGRESS,
  FETCH_KEYWORD_OVERVIEW_SUCCESSFUL,
  FETCH_KEYWORD_OVERVIEW_FAILED,
  CHANGE_SEO_DB_IN_PROGRESS,
  CHANGE_SEO_DB_SUCCESSFUL,
  CHANGE_SEO_DB_FAILED,
  DELETE_KEYWORD_IN_PROGRESS,
  DELETE_KEYWORD_FAILED,
  DELETE_KEYWORD_SUCCESSFUL,
  ADD_KEYWORDS_IN_PROGRESS,
  ADD_KEYWORDS_SUCCESSFUL,
  ADD_KEYWORDS_FAILED
} from "./types";

import { LOGOUT } from "../iam/types";

const network_activity_messages = {
  tracked_keywords: "fetch_tracked_keywords_",
  keywords_count: "fetch_keywords_count",
  top_domains: "fetch_top_domains_",
  overviews: "fetch_overview_",
  change_seo_db: "change_seo_db_",
  delete_keyword: "deleting_keyword_",
  add_tracked_keywords: "add_tracked_keywords_"
};

const initialState = {
  network_activity: [],
  domains: {},
  overviews: {},
  top_domains: {},
  tracked_keywords_count: null
};

const trackedKeywordsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_TRACKED_KEYWORDS_IN_PROGRESS:
      return {
        ...state,
        network_activity: [...state.network_activity, `${network_activity_messages["tracked_keywords"]}${action.guid}`]
      };
    case FETCH_TRACKED_KEYWORDS_SUCCESSFUL:
      return {
        ...state,
        network_activity: state.network_activity.filter(
          item => item !== `${network_activity_messages["tracked_keywords"]}${action.guid}`
        ),
        domains: {
          ...state.domains,
          [action.guid]: {
            keywords: action.keywords,
            seo_db: action.seo_db
          }
        }
      };
    case FETCH_TRACKED_KEYWORDS_FAILED:
      return {
        ...state,
        network_activity: state.network_activity.filter(
          item => item !== `${network_activity_messages["tracked_keywords"]}${action.guid}`
        )
      };
    case FETCH_TRACKED_KEYWORDS_COUNT_IN_PROGRESS:
      return {
        ...state,
        network_activity: [...state.network_activity, network_activity_messages["keywords_count"]]
      };
    case FETCH_TRACKED_KEYWORDS_COUNT_SUCCESSFUL:
      return {
        ...state,
        network_activity: state.network_activity.filter(item => item !== network_activity_messages["keywords_count"]),
        tracked_keywords_count: action.keywords_count
      };
    case FETCH_TRACKED_KEYWORDS_COUNT_FAILED:
      return {
        ...state,
        network_activity: state.network_activity.filter(item => item !== network_activity_messages["keywords_count"])
      };
    case FETCH_TOP_DOMAINS_IN_PROGRESS:
      return {
        ...state,
        network_activity: [...state.network_activity, `${network_activity_messages["top_domains"]}${action.h_key}`]
      };
    case FETCH_TOP_DOMAINS_SUCCESSFUL:
      return {
        ...state,
        network_activity: state.network_activity.filter(
          item => item !== `${network_activity_messages["top_domains"]}${action.h_key}`
        ),
        domains: {
          ...state.domains,
          [action.guid]: {
            ...state.domains[action.guid],
            keywords: state.domains[action.guid].keywords.map(keyword => {
              if (keyword.phrase === action.keyword) {
                return { ...keyword, top_domains: action.h_key };
              }
              return keyword;
            })
          }
        },
        top_domains: {
          ...state.top_domains,
          [action.h_key]: action.top_domains
        }
      };
    case FETCH_TOP_DOMAINS_FAILED:
      return {
        ...state,
        network_activity: state.network_activity.filter(
          item => item !== `${network_activity_messages["top_domains"]}${action.h_key}`
        )
      };
    case FETCH_KEYWORD_OVERVIEW_IN_PROGRESS:
      return {
        ...state,
        network_activity: [...state.network_activity, `${network_activity_messages["overviews"]}${action.h_key}`]
      };
    case FETCH_KEYWORD_OVERVIEW_SUCCESSFUL:
      return {
        ...state,
        network_activity: state.network_activity.filter(
          item => item !== `${network_activity_messages["overviews"]}${action.h_key}`
        ),
        domains: {
          ...state.domains,
          [action.guid]: {
            ...state.domains[action.guid],
            keywords: state.domains[action.guid].keywords.map(keyword => {
              if (keyword.phrase === action.keyword) {
                return { ...keyword, overview: action.overview };
              }
              return keyword;
            })
          }
        },
        overviews: {
          ...state.overviews,
          [action.h_key]: action.overview
        }
      };
    case FETCH_KEYWORD_OVERVIEW_FAILED:
      return {
        ...state,
        network_activity: state.network_activity.filter(
          item => item !== `${network_activity_messages["overviews"]}${action.h_key}`
        )
      };
    case CHANGE_SEO_DB_IN_PROGRESS:
      return {
        ...state,
        network_activity: [...state.network_activity, `${network_activity_messages["change_seo_db"]}${action.guid}`]
      };
    case CHANGE_SEO_DB_SUCCESSFUL:
      return {
        ...state,
        network_activity: state.network_activity.filter(
          item => item !== `${network_activity_messages["change_seo_db"]}${action.guid}`
        ),
        domains: {
          ...state.domains,
          [action.guid]: {
            ...state.domains[action.guid],
            seo_db: action.new_seo_db
          }
        }
      };
    case CHANGE_SEO_DB_FAILED:
      return {
        ...state,
        network_activity: state.network_activity.filter(
          item => item !== `${network_activity_messages["change_seo_db"]}${action.guid}`
        )
      };
    case DELETE_KEYWORD_IN_PROGRESS:
      return {
        ...state,
        network_activity: [
          ...state.network_activity,
          `${network_activity_messages["delete_keyword"]}${action.keyword}${action.guid}`
        ]
      };
    case DELETE_KEYWORD_SUCCESSFUL:
      return {
        ...state,
        network_activity: state.network_activity.filter(
          item => item !== `${network_activity_messages["delete_keyword"]}${action.keyword}${action.guid}`
        ),
        domains: {
          ...state.domains,
          [action.guid]: {
            ...state.domains[action.guid],
            keywords: state.domains[action.guid].keywords.filter(keyword => keyword.phrase !== action.keyword)
          }
        }
      };
    case DELETE_KEYWORD_FAILED:
      return {
        ...state,
        network_activity: state.network_activity.filter(
          item => item !== `${network_activity_messages["delete_keyword"]}${action.keyword}${action.guid}`
        )
      };
    case ADD_KEYWORDS_IN_PROGRESS:
      return {
        ...state,
        network_activity: [
          ...state.network_activity,
          `${network_activity_messages["add_tracked_keywords"]}${action.domain}`
        ]
      };
    case ADD_KEYWORDS_SUCCESSFUL:
      return {
        ...state,
        network_activity: state.network_activity.filter(
          item => item !== `${network_activity_messages["add_tracked_keywords"]}${action.domain}`
        )
      };
    case ADD_KEYWORDS_FAILED:
      return {
        ...state,
        network_activity: state.network_activity.filter(
          item => item !== `${network_activity_messages["add_tracked_keywords"]}${action.domain}`
        )
      };
    case LOGOUT:
      return {
        ...state,
        ...initialState
      };
    default:
      return state;
  }
};

export default trackedKeywordsReducer;
